import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Icon from '../../../modules/react/components/stateless/Icon';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  placement: PropTypes.string,
};

const defaultProps = {
  className: undefined,
  placement: 'right',
};

const FormFieldLabelTooltip = ({
  className,
  text,
  placement,
}) => {
  const overlay = (
    <Tooltip id="form-field-label-tooltip" className={styles.tooltipText}>
      {text}
    </Tooltip>
  );

  const classes = cx(
    styles.tooltip,
    className,
  );

  return (
    <OverlayTrigger
      overlay={overlay}
      placement={placement}
    >
      <span className={classes}>
        <Icon id="tool-tip" label="tooltip" />
      </span>
    </OverlayTrigger>
  );
};

FormFieldLabelTooltip.propTypes = propTypes;
FormFieldLabelTooltip.defaultProps = defaultProps;

export default FormFieldLabelTooltip;
